export const iconFontAwesomeTextformattingFont = (
	<i className="fa-solid fa-font"></i>
);
